export default function cloudinaryLoader({ src, width, quality }: {src: string, width: number, quality: number}) {
  // Local images svg
  if (src.endsWith('.svg')) {
    return src
  }

  // External image to be Optimized
  let method = 'upload'
  const params = ['f_auto', 'c_fill', `w_${width}`, `q_${quality || 'auto'}`]

  if (src.startsWith('http')) {
    method = 'fetch'
  }

  return `https://res.cloudinary.com/${process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME}/image/${method}/${params.join(',')}/${encodeURIComponent(src)}`
}